import { Box, Button, Divider, Grid, Typography } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";

import { NotificationEvent } from "@dashboard-v3/api";
import {
  PropertyData,
  PropertyLabel,
} from "components/EmailEventDetails/styled";

const MALWARE_PATH = "/malware";

export default function MalwareDetectedDetails({
  notification,
}: {
  notification: NotificationEvent;
}) {
  const { t } = useTranslation("notifications");
  const { fileName, filePath, user, threats, filesCount } = notification.data;
  const otherFiles = Math.max(Number(filesCount ?? 0) - 1, 0);

  const properties = [
    {
      key: "file",
      label: t("malwareDetected.file"),
      value: fileName,
    },
    {
      key: "folder",
      label: t("malwareDetected.folder"),
      value: filePath || "/",
    },
    {
      key: "owner",
      label: t("malwareDetected.owner"),
      value: user,
    },
    {
      key: "threat",
      label: t("malwareDetected.threat"),
      value: threats,
    },
  ];

  return (
    <Box data-testid="notification-malware-detected">
      <Divider />

      <Box mt={2}>
        <Alert severity="error">
          <AlertTitle>
            {t("malwareDetected.title", {
              fileName,
              interpolation: { escapeValue: false },
            })}
          </AlertTitle>
          {t("malwareDetected.description")}
        </Alert>
      </Box>

      <Grid container spacing={2} style={{ marginTop: "12px" }}>
        {properties.map(({ key, label, value }) => (
          <Grid item xs={12} sm={6} lg={3} key={key}>
            <PropertyLabel>{label}</PropertyLabel>
            <PropertyData data-testid={`notification-malware-detected-${key}`}>
              {value}
            </PropertyData>
          </Grid>
        ))}
      </Grid>

      {otherFiles > 0 && (
        <Box mt={2}>
          <Typography
            variant="body2"
            color="textSecondary"
            data-testid="notification-malware-detected-more"
          >
            {t("malwareDetected.moreFiles", { count: otherFiles })}
          </Typography>
        </Box>
      )}

      <Box mt={2}>
        <Button
          component={RouterLink}
          to={MALWARE_PATH}
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          variant="outlined"
          data-testid="notification-malware-detected-link"
        >
          {t("malwareDetected.goToMalware")}
        </Button>
      </Box>
    </Box>
  );
}
